import {AppActionTypes, LOGIN, LOGOUT, REGISTER} from "./actions";
import {AppState} from "../models/AppState";

const reducer = (state: AppState, action: AppActionTypes): AppState => {
    switch (action.type) {
        case LOGIN:
            return {...state, customer: action.payload.customer};
        case REGISTER:
            return {...state, customer: action.payload.customer};
        case LOGOUT:
            return {...state, customer: null};
        default:
            return state;
    }
};

export default reducer; // Directly export the reducer function as the default export
